import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { TopBar } from 'components/molecules/TopBar';
import Sidebar from './Sidebar';
import useStyle from './loggedLayout.style';
import { matchPath, useLocation } from 'react-router-dom';
import { getPageNameFromPath } from '../../../helpers/page/getpageNameFromPath';
import { getFirstName } from '../../../store/selectors/user/user.selectors';
import { isOnDashboard } from '../../../routes/useCases';
import { BottomMenu } from '../../organisms/Menus/BottomMenu';
import pages, { bottomMenuPages } from '../../../routes/pages';
import { Footer } from '../../molecules/Footer';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

interface LayoutProps {
  children: React.ReactElement;
  menu?: React.ReactElement;
  shopId?: string | null;
}

const LoggedLayout = React.memo(
  ({ children, menu, shopId = null }: LayoutProps) => {
    const username = useSelector(getFirstName);
    const location = useLocation();
    const title = isOnDashboard(location.pathname)
      ? username
      : getPageNameFromPath(location.pathname)?.displayName;
    const userIsOnQuizGamePage =
      matchPath(location.pathname, {
        path: pages.QUIZ_SINGLE_PAGE.path,
        exact: true
      }) && true;

    const classes: Record<string, string> = useStyle();

    return (
      <>
        <TopBar
          title={title}
          onDashboard={isOnDashboard(location.pathname)}
          variant={CURRENT_CHALLENGE_SEASON}
          hideLogOut={!!shopId}
          emoji={getPageNameFromPath(location.pathname)?.emoji}
        />
        {!shopId && (
          <div className={classes.LoggedDrawerPaper}>
            <Sidebar publicLayout={!!shopId} menu={menu} />
          </div>
        )}
        <main
          id={'main'}
          className={classNames(classes.LoggedContent, {
            [classes.LoggedContentShift]: !shopId
          })}
        >
          <div className={classes.LoggedMainContainer}>
            {children}
            {!userIsOnQuizGamePage && (
              <div className={classes.bottomMenuContainer}>
                {!shopId && <BottomMenu pagesProps={bottomMenuPages} />}
              </div>
            )}
          </div>
        </main>
        <Footer shopId={shopId} />
      </>
    );
  }
);

LoggedLayout.displayName = 'LoggedLayout';

export default LoggedLayout;
